import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SubscribeGuard implements CanActivate {
  userDetails: any;
  isAllowed: string | null;
  demoView: boolean = false;

  constructor(private router: Router, private authService: AuthService) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const routePath = next.routeConfig?.path;
    const verified = await this.authService.checkIfUserVerified();
    // console.log('SubscribeGuard verified', verified);
    if (verified) {
      try {
        this.userDetails = await this.authService.setAndGetCurrentUser();
        // console.log('SubscribeGuard userDetails', this.userDetails);
        if (environment.demoView === 'true') {
          this.demoView = true;
        } else {
          this.demoView = false;
        }
        const isSubscribe =
          this.userDetails?.subscribed ||
          this.demoView ||
          this.userDetails?.user_plan === 1 ||
          routePath === 'whats-new';
        if (!isSubscribe) {
          localStorage.removeItem('routeChange');
        }
        this.isAllowed = localStorage.getItem('routeChange');

        if (isSubscribe && !this.isAllowed) {
          return true; // Allow access to the route
        } else if (this.isAllowed) {
          return false;
        } else {
          this.router.navigate(['/deposit']);
          return false; // Deny access to the route
        }
      } catch (error) {
        return false;
      }
    }
    return true;
  }
}
